import { Events, AppNames, Platform, DeviceType } from '@/models/analytics';
export function getCurrentTimestamp() {
  const now = new Date();

  const year = now.getUTCFullYear();
  const month = String(now.getUTCMonth() + 1).padStart(2, '0');
  const day = String(now.getUTCDate()).padStart(2, '0');
  const hours = String(now.getUTCHours()).padStart(2, '0');
  const minutes = String(now.getUTCMinutes()).padStart(2, '0');
  const seconds = String(now.getUTCSeconds()).padStart(2, '0');

  return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}Z`;
}

export function getDevice() {
  const platform = navigator.platform;
  let device = 'Unknown';
  if (platform.indexOf('Win') > -1) {
    device = Platform.WEB;
  } else if (platform.indexOf('Mac') > -1) {
    device = Platform.IOS;
  } else if (platform.indexOf('Linux') > -1) {
    device = 'Linux';
  } else if (platform.indexOf('Android') > -1) {
    device = Platform.Android;
  } else if (platform.indexOf('iPhone') > -1 || platform.indexOf('iPad') > -1) {
    device = Platform.IOS;
  }
  return device;
}

export function detectDeviceType() {
  const userAgent = navigator.userAgent.toLowerCase();

  if (/mobile/i.test(userAgent)) {
    return DeviceType.Mobile;
  } else if (/tablet/i.test(userAgent)) {
    return DeviceType.Tablet;
  } else {
    return DeviceType.Web;
  }
}
export const initialData = () => {
  return {
    app: AppNames.tv,
    event: Events.OPEN_APP,
    countryCode: localStorage.getItem('kdj_cc') || 'US',
    timestamp: getCurrentTimestamp(),
    env: process.env.VUE_APP_ANALYTICS_ENV,
    // query: {
    //   data: 'search title given by user',
    //   category: 'On select of any category',
    // },
    device: {
      platform: Platform.WEB,
      deviceType: detectDeviceType(),
    },
  };
};
